<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card v-if="dialog" class="admin-open-orders-by-table-dialog">
        <v-toolbar
          dark
          :color="color"
          class="justify-content-between open-order-header"
        >
          <v-toolbar-items class="table-dialog-heading pa-2">
            <v-btn icon dark @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>MESA {{ tableQRLabel(tableQR) }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar-items>
          <v-toolbar-items class="pa-2">
            <span class="text-h6"
              >FALTA PAGAR : {{ formatPrice(remaining) }}</span
            >
          </v-toolbar-items>
        </v-toolbar>
        <div class="d-flex flex-column">
          <v-btn dark color="brown" class="mx-2 my-2" @click="printTicket"
            >IMPRIMIR CUENTA
          </v-btn>
          <v-btn
            v-if="remaining > 0"
            dark
            color="brown"
            class="mx-2 my-2"
            @click="generatePayment"
            >GENERAR PAGO
          </v-btn>
          <v-btn
            dark
            color="brown"
            v-if="!hasRoleWaiter"
            class="mx-2 my-2"
            @click="openUnPaidDialog"
            >CERRAR CUENTA
          </v-btn>
          <v-btn
            dark
            color="brown"
            v-if="hasRoleWaiter"
            class="mx-2 my-2"
            @click="closePaidAccount"
            >CERRAR CUENTA
          </v-btn>
          <v-btn
            dark
            color="brown"
            class="mx-2 my-2"
            @click="clickMarcharSegundos"
            v-if="showMarcharSegundos"
            >MARCHAR SEGUNDOS
          </v-btn>
        </div>
        <v-list class="mx-3">
          <template v-for="(payment, index) in payments">
            <v-alert
              type="error"
              prominent
              class="text-uppercase"
              :key="`payment_${index}`"
            >
              <v-row align="center">
                <v-col class="grow"
                  >Peticion de pago
                  {{
                    payment.payment_method === paymentMethodCash
                      ? "en efectivo"
                      : "con datáfono"
                  }}
                  de:
                  {{ formatPrice(amountToPay(payment)) }}
                </v-col>
                <v-col v-if="!hasRoleWaiter">
                  <v-btn
                    color="orange"
                    class="shrink mx-2 mt-1"
                    @click="removeFromPayment(payment)"
                  >
                    Descartar
                  </v-btn>
                  <v-btn
                    class="shrink mx-2 mt-1"
                    style="background-color: #272727"
                    @click="
                      $refs.paymentChangeDialogRef.openDialog(orders, payment)
                    "
                    :disabled="!remaining"
                  >
                    Pagar
                  </v-btn>
                </v-col>
              </v-row>
            </v-alert>
          </template>
        </v-list>
        <v-list class="mx-2">
          <v-list-item
            v-for="(orderGroupByTime, time) in ordersGroupByTime"
            :key="`order${time}`"
          >
            <OrderByTime
              :selectedPrinters="selectedPrinters"
              @setRemaing="setRemaing($event)"
              :orders="orderGroupByTime"
              :time="time"
              :table="tableQR"
              :remaining="remaining"
              @deleteOrder="deleteOrder($event)"
              @isDeliveredChecked="isDeliveredChecked($event)"
              @isMainCourseDeliveredChecked="
                isMainCourseDeliveredChecked($event)
              "
              @isDeliveredCheckedMenuGroup="isDeliveredCheckedMenuGroup($event)"
              @isMainCourseDeliveredCheckedMenuGroup="
                isMainCourseDeliveredCheckedMenuGroup($event)
              "
              ref="orderBytimeRef"
            ></OrderByTime>
          </v-list-item>
        </v-list>
        <v-card-actions>
          <v-alert
            width="100%"
            class="d-flex justify-center"
            type="info"
            color="grey"
            style="font-size: 18px"
          >
            <b
              >TOTAL DE LA CUENTA:
              {{ formatPrice(total - getInvitationTotalPrice) }}
            </b>
          </v-alert>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <PaymentChangeDialog
      @setRemaing="setRemaing($event)"
      ref="paymentChangeDialogRef"
    />

    <v-row justify="center">
      <OrderUnpaidDialog
        :dialogUnPaid="dialogUnPaid"
        @cancel="unPaidCancel"
        @unPaidOrder="unPaidOrder"
      ></OrderUnpaidDialog>
    </v-row>

    <v-row justify="center">
      <OrderNotDeliveredDialog
        :dialogOrderNotDelivered="dialogOrderNotDelivered"
        @cancelDialogNotDelivered="cancelDialogNotDelivered"
        @closeAccounts="closeAccounts"
      ></OrderNotDeliveredDialog>
    </v-row>
    <product-chooser-dialog
      :tableQr="tableQR"
      ref="productChooserDialogRef"
      :unpaid-total-price="remaining"
      :total-price-all-orders="total"
      @setRemaing="setRemaing($event)"
      @setOrders="setOrders($event)"
    ></product-chooser-dialog>
  </div>
</template>

<script>
import OrderByTime from "@/components/admin/order/OrderByTime";
import OrderUnpaidDialog from "@/components/admin/order/OrderUnpaidDialog";
import OrderNotDeliveredDialog from "@/components/admin/order/OrderNotDeliveredDialog";
import PaymentChangeDialog from "@/components/admin/payment/PaymentChangeDialog";
import ProductChooserDialog from "@/components/admin/payment/generalpayment/ProductChooserDialog";
import moment from "moment";

import { firestoreTimestamp } from "@/firebaseConfig";
import firebaseMixin from "@/mixins/firebase/firebaseMixin";
import paymentsMixin from "@/mixins/payment/paymentsMixin";
import { every } from "lodash";
import printerMixin from "@/mixins/printer/printerMixin";
import { zClosuresCollection } from "@/collections/zClousures";
import { deletePayment, paymentsCollection } from "@/collections/payments";
import { printersCollection } from "@/collections/printers";
import { saveOrder, updateOrder } from "@/collections/orders";
import { saveUnPaidOrder } from "@/collections/unPaidOrders";
import {
  ordersTotalByTableCollection,
  saveOrderTotalByTable
} from "@/collections/ordersTotalByTable";
import { deleteUserCart, userCartCollection } from "@/collections/userCart";

export default {
  name: "open-order-by-table-dialog",
  props: {
    selectedPrinters: Array,
    selectedPrinterTicket: Object,
    selectedDrawer: Object,
    cashDrawers: Array
  },
  mixins: [firebaseMixin, paymentsMixin, printerMixin],
  components: {
    OrderByTime,
    PaymentChangeDialog,
    OrderUnpaidDialog,
    OrderNotDeliveredDialog,
    ProductChooserDialog
  },
  data() {
    return {
      dialog: false,
      dialogUnPaid: false,
      dialogOrderNotDelivered: false,
      remaining: 0,
      tableQR: null,
      color: null,
      orders: [],
      ordersTotalByTable: [],
      paymentsCollection: [],
      zClosuresLastDoc: [],
      userCartCollection: [],
      tableOrderPayment: null,
      printers: []
    };
  },
  firestore() {
    return {
      ordersTotalByTable: ordersTotalByTableCollection,
      paymentsCollection: paymentsCollection.where("payment_on", "==", null),
      zClosuresLastDoc: zClosuresCollection
        .where("closed_on", "==", null)
        .orderBy("opened_on", "desc")
        .limit(1),
      userCartCollection: userCartCollection,
      printers: printersCollection.where("active", "==", true)
    };
  },
  watch: {
    remaining(val) {
      if (!val) {
        this.payments?.length > 1
          ? this.payments.forEach(payment => {
              deletePayment(payment.id).catch(error => {
                this.setlogError(
                  "delete_payment",
                  "Obtained error message in remaining() watch",
                  error.stack,
                  this.$options.name
                );
              });
            })
          : "";
      }
      this.remaining = val;
    }
  },
  computed: {
    total() {
      return this.orders
        .map(x => x.price * x.quantity + this.totalWithAdditionalCharge(x))
        .reduce((x, y) => x + y, 0);
    },
    getInvitationTotalPrice() {
      let total = 0;
      this.orders.forEach(item => {
        if (item.selectOption === "invitation") {
          total +=
            item.removeQuantity * item.price +
            this.totalWithAdditionalCharge(item);
        }
      });
      return total;
    },
    showMarcharSegundos() {
      const { food } = this.$store.state.productTypeIds;
      let filterOrder = this.orders.filter(
        x =>
          (x.product_type_id === food &&
            x.metadata &&
            !x.canBeShared &&
            x.canBeMainCourse) ||
          false
      );

      let menuGroupOrder = this.orders.filter(item => {
        if (item.isMenuGroupProduct) {
          return item;
        }
      });

      let findMainCourse = menuGroupOrder.some(item => {
        if (item.maincourse && item.maincourse.length > 0) {
          return item;
        }
      });
      return findMainCourse ? findMainCourse : filterOrder.length > 0;
    },
    ordersGroupByTime() {
      return this.arrayGroupBy(this.orders, "time");
    },
    payments() {
      return this.arrayGroupBy(this.paymentsCollection, "tableQR")[
        this.tableQR
      ];
    },
    hasRoleWaiter() {
      return this.$store.getters.hasRoleWaiter;
    }
  },
  methods: {
    generatePayment() {
      let found = false;
      if (Object.keys(this.selectedDrawer).length > 0) {
        found = this.cashDrawers.some(cashDrawer => {
          if (cashDrawer.id === this.selectedDrawer.id) {
            return cashDrawer;
          }
        });
      }

      if (
        this.cashDrawers.length > 0 &&
        (Object.keys(this.selectedDrawer).length === 0 || found === false)
      ) {
        this.showErrorMessage("No has seleccionado ningún cajón!");
      }
      this.$refs.productChooserDialogRef.open();
    },
    setRemaing(value) {
      this.remaining = value;
      if (this.remaining === 0) {
        this.color = "#4caf50";
      }
    },
    setOrders(orders) {
      this.orders = orders;
    },
    open(remaining, table, color, orders) {
      this.dialog = true;
      this.remaining = remaining;
      this.tableQR = table;
      this.color = color;
      this.orders = orders;
    },
    close() {
      this.dialog = false;
    },
    closePaidAccount() {
      if (this.remaining !== 0) {
        this.showInfoMessage(
          `¡No se puede cerrar la cuenta, importe pendiente: ${this.formatPrice(
            this.remaining
          )} !`
        );
        return;
      }

      const { food } = this.$store.state.productTypeIds;
      let filterOrder = this.orders.filter(
        x =>
          (x.product_type_id === food &&
            x.metadata &&
            !x.canBeShared &&
            x.canBeMainCourse) ||
          false
      );

      let menuGroupOrder = this.orders.filter(item => {
        if (item.isMenuGroupProduct) {
          return item;
        }
      });

      let maincourseOrders = [];

      menuGroupOrder.forEach(item => {
        if (item.maincourse && item.maincourse.length > 0) {
          maincourseOrders = [...maincourseOrders, ...item.maincourse];
        }
      });

      let allOrders = [...filterOrder, ...maincourseOrders];

      let isDeliveredMainCourseAll = every(allOrders, [
        "isDeliveredMainCourse",
        true
      ]);

      if (!isDeliveredMainCourseAll) {
        this.dialogOrderNotDelivered = true;
        return;
      }

      this.unPaidOrder();
      // clear user cart
      this.deteteUserCart();
    },
    printTicket() {
      if (!this.printersAreActive) {
        this.showErrorMessage("Las impresoras no estan activas");
        return;
      }
      if (Object.keys(this.selectedPrinterTicket).length === 0) {
        this.showErrorMessage("No has seleccionado todas las impresoras!");
        return;
      }
      let printerData = this.selectedPrinterTicket;
      console.log("printerData", printerData);
      const url = `${printerData.url}&id=${this.tableQR}`;
      console.log("url", url);
      let array = [];
      this.orders.forEach(item => {
        if (item.menu_group_id) {
          array.push({
            id: item.id,
            quantity: item.quantity,
            concept: item.order || item.name,
            price: item.price * item.quantity,
            size: item.size,
            notes: item.notes,
            canBeMainCourse: item.canBeMainCourse || false,
            canBeShared: item.canBeShared || false
            // big: this.isBig(item, printerData)
          });
        } else {
          array.push({
            id: item.id,
            quantity: item.quantity,
            concept: item.order || item.name,
            price: item.price * item.quantity,
            size: item.size,
            notes: item.notes,
            canBeMainCourse: item.canBeMainCourse || false,
            canBeShared: item.canBeShared || false
            // big: this.isBig(item, printerData)
          });
        }
      });
      let comments = [];
      const data = this.buildPrinterData(
        array,
        this.tableQR,
        comments,
        this.orders
      );
      data.isareceipt = true;
      data.remainingPayment = this.remaining;
      console.log("data", data);
      let printerName = "";
      if (printerData.name) {
        printerName = printerData.name;
      }
      console.log("printerName", printerName);
      this.postPrinterRequest(url, data, printerName, "open-orders");
    },
    clickMarcharSegundos() {
      let filterMenuOrder = this.orders.filter(item => {
        if (item.isMenuGroupProduct) {
          return item;
        }
      });

      if (filterMenuOrder && filterMenuOrder.length > 0) {
        filterMenuOrder.forEach(item => {
          this.clickMarcharSegundosMenuGroup(this.tableQR, item);
        });
      }
      if (
        !this.selectedPrinters ||
        (this.selectedPrinters && !this.selectedPrinters.length)
      ) {
        this.showErrorMessage("No hay ninguna impresora seleccionada!");
        return;
      }

      this.makePrinterCall(
        this.orders,
        this.tableQR,
        this.printers,
        "open-orders"
      );

      this.orders.forEach(item => {
        updateOrder(item.id, { isDelivered: true, isPrinted: true }).catch(
          error => {
            this.setlogError(
              "update_order",
              "Obtained error message in clickMarcharSegundos()",
              error.stack,
              this.$options.name
            );
          }
        );
      });

      this.$emit("changeTableToMarcharSegundo", this.tableQR);
      this.$refs.orderBytimeRef[0].stopTimer(this.tableQR);

      this.showSuccessMessage("Se ha enviado a cocina MARCHAR SEGUNDOS!");
    },
    async clickMarcharSegundosMenuGroup(table, item) {
      try {
        item.starters.map(starter => {
          starter.isPrinted = true;
          return starter;
        });
        await updateOrder(item.id, { starters: item.starters });

        item.maincourse.map(main => {
          main.isPrinted = true;
          return main;
        });
        await updateOrder(item.id, { maincourse: item.maincourse });

        item.desserts.map(dessert => {
          dessert.isPrinted = true;
          return dessert;
        });
        await updateOrder(item.id, { desserts: item.desserts });

        item.drinks.map(drink => {
          drink.isPrinted = true;
          return drink;
        });
        await updateOrder(item.id, { drinks: item.drinks });

        let allItems = [];
        allItems = [
          ...allItems,
          ...item.starters,
          ...item.maincourse,
          ...item.desserts,
          ...item.drinks
        ];
        return allItems;
      } catch (error) {
        this.setlogError(
          "update_order",
          "Obtained error message in clickMarcharSegundosMenuGroup()",
          error.stack,
          this.$options.name
        );
      }
    },
    openUnPaidDialog() {
      if (this.remaining > 0) {
        this.dialogUnPaid = true;
        return;
      }

      const { food } = this.$store.state.productTypeIds;
      let filterOrder = this.orders.filter(
        x =>
          (x.product_type_id === food &&
            x.metadata &&
            !x.canBeShared &&
            x.canBeMainCourse) ||
          false
      );

      let menuGroupOrder = this.orders.filter(item => {
        if (item.isMenuGroupProduct) {
          return item;
        }
      });

      let maincourseOrders = [];

      menuGroupOrder.forEach(item => {
        if (item.maincourse && item.maincourse.length > 0) {
          maincourseOrders = [...maincourseOrders, ...item.maincourse];
        }
      });

      let allOrders = [...filterOrder, ...maincourseOrders];

      let isDeliveredMainCourseAll = every(allOrders, [
        "isDeliveredMainCourse",
        true
      ]);

      if (!isDeliveredMainCourseAll) {
        this.dialogOrderNotDelivered = true;
        return;
      }

      this.unPaidOrder();
      // clear user cart
      this.deteteUserCart();
    },
    deteteUserCart() {
      let filterUserCart = this.userCartCollection.filter(item => {
        if (item.tableQR === this.tableQR) {
          return item;
        }
      });
      if (filterUserCart && filterUserCart.length > 0) {
        filterUserCart.forEach(cart => {
          deleteUserCart(cart.id).catch(error => {
            this.setlogError(
              "delete_user_cart",
              "Obtained error message in deteteUserCart()",
              error.stack,
              this.$options.name
            );
          });
        });
      }
    },
    unPaidCancel() {
      this.dialogUnPaid = false;
      if (this.remaining > 0) {
        this.showErrorMessage(
          "No se puede cerrar la cuenta porque hay pagos pendientes"
        );
      }
    },
    cancelDialogNotDelivered() {
      this.dialogOrderNotDelivered = false;
    },
    closeAccounts() {
      this.unPaidOrder();
      // clear user cart
      this.deteteUserCart();
      this.dialogOrderNotDelivered = false;
    },
    async unPaidOrder() {
      try {
        let cloneOrders = JSON.parse(JSON.stringify(this.orders));

        let now = moment().format();

        let lastElement = this.zClosuresLastDoc
          ? this.zClosuresLastDoc[0]
          : null;

        if (this.remaining > 0 && lastElement) {
          let data = {
            products: cloneOrders.map(order => {
              return order.product_id;
            }),
            amount: this.remaining,
            email: cloneOrders[0].email,
            table: cloneOrders[0].tableQR,
            time: now,
            zcloser_id: lastElement ? lastElement.id : null
          };

          await saveUnPaidOrder(data);
        }

        // eslint-disable-next-line no-unused-vars
        let _orders = [...this.orders].map(item => {
          if (item.metadata) {
            // eslint-disable-next-line no-unused-vars
            for (const [quantity, metadata] of Object.entries(item.metadata)) {
              if (item.metadata[quantity].isSelected) {
                item.metadata[quantity].isPaid = true;
              }
            }
          }
          item.isOpen = false;
          item.orderClosedAt = now;
          saveOrder(item.id, item).catch(error => {
            this.setlogError(
              "save_order",
              "Obtained error message in unPaidOrder()",
              error.stack,
              this.$options.name
            );
          });
          return item;
        });
        // orders, remaining_amount, paid_amount
        // eslint-disable-next-line no-unused-vars
        let paidAmount = 0;
        if (parseInt(this.remaining) !== 0) {
          paidAmount = this.total - this.remaining;
        }

        this.tableOrderPayment = this.payment;

        // Remove unpaid payment requests
        this.payments &&
          this.payments.forEach(payment => {
            deletePayment(payment.id).catch(error => {
              this.setlogError(
                "delete_payment",
                "Obtained error message in unPaidOrder()",
                error.stack,
                this.$options.name
              );
            });
          });

        this.updateOrderTotalAmount(this.tableQR, false, 0, true);
        this.showSuccessMessage("Cuenta cerrada correctamente!");
        this.close();

        this.dialogUnPaid = false;
      } catch (error) {
        this.setlogError(
          "save_unPaid_order",
          "Obtained error message in unPaidOrder()",
          error.stack,
          this.$options.name
        );
        this.showErrorMessage("Algo salió mal");
      }
    },
    async updateOrderTotalAmount(
      tableQR,
      isPaid = false,
      price = 0,
      allDone = false
    ) {
      let time = firestoreTimestamp.fromDate(new Date());
      try {
        this.disabled = true;
        let orderTotal = this.ordersTotalByTable.find(
          x => x.tableQR === tableQR
        );
        if (orderTotal) {
          if (isPaid) {
            orderTotal.remaining -= price;
            if (orderTotal.remaining < 0) {
              orderTotal.remaining = 0;
            }
          } else {
            orderTotal.remaining += price;
          }
          if (allDone) {
            orderTotal.remaining = 0;
          }
          orderTotal.time = time;
          await saveOrderTotalByTable(tableQR, orderTotal);
        }
      } catch (error) {
        // eslint-disable-next-line
        this.setlogError(
          "save_order_total_by_table",
          "Obtained error message in updateOrderTotalAmount()",
          error.stack,
          this.$options.name
        );
      } finally {
        this.disabled = false;
      }
    },
    deleteOrder(item) {
      if (item.selectOption === "invitation") {
        this.orders = this.orders.map(order => {
          if (order.id === item.id) {
            order.selectOption = item.selectOption;
            order.removeQuantity = item.removeQuantity;
          }
          return order;
        });
      } else {
        let index = this.orders.findIndex(x => x.id === item.id);
        this.orders.splice(index, 1);
      }
    },
    async removeFromPayment(payment) {
      try {
        await deletePayment(payment.id);
      } catch (error) {
        this.setlogError(
          "delete_payment",
          "Obtained error message in removeFromPayment()",
          error.stack,
          this.$options.name
        );
      }
    },
    isDeliveredCheckedMenuGroup(event) {
      this.orders = this.orders.map(item => {
        if (item.isMenuGroupProduct) {
          if (item.id === event.item.id) {
            item.starters.map(x => {
              if (x.id === event.groupItem.id) {
                x.isDelivered = event.groupItem.isDelivered;
              }
              return x;
            });
          }
        }
        return item;
      });
    },
    isDeliveredChecked(event) {
      this.orders = this.orders.map(item => {
        if (item.id === event.id) {
          item.isDelivered = event.isDelivered;
        }
        return item;
      });
    },
    isMainCourseDeliveredChecked(event) {
      this.orders = this.orders.map(item => {
        if (item.id === event.id) {
          item.isDeliveredMainCourse = true;
        }
        return item;
      });
    },
    isMainCourseDeliveredCheckedMenuGroup(event) {
      this.orders = this.orders.map(item => {
        if (item.isMenuGroupProduct) {
          if (item.id === event.item.id) {
            item.maincourse.map(x => {
              if (x.id === event.groupItem.id) {
                x.isDeliveredMainCourse = event.groupItem.isDeliveredMainCourse;
              }
              return x;
            });
          }
        }
        return item;
      });
    },
    playMusic() {
      let audio = new Audio(this.projectUrl + "/music/OneRingfromDeskBell.mp3");
      audio.play();
    }
  }
};
</script>

<style lang="scss">
.table-dialog-heading {
  width: 80%;
  align-items: center;
  display: flex;
}
@media screen and (max-width: 768px) {
  .open-order-header .v-toolbar__content {
    padding: 4px 5px;
  }
  .open-order-header .v-btn:not(.v-btn--round).v-size--default {
    padding: 0 8px;
  }
  .open-order-header .v-application .text-h6 {
    font-size: 1.1rem !important;
  }
}
@media screen and (max-width: 715px) {
  header.justify-content-between {
    height: auto !important;
  }
  .open-order-header .v-toolbar__content {
    flex-direction: column;
    height: auto !important;
    padding: 10px 15px 5px 5px;
  }
  .table-dialog-heading {
    width: 100%;
  }
  .open-order-header .v-btn:not(.v-btn--round).v-size--default {
    padding: 10px 8px;
  }
  .open-order-header .v-alert--prominent .v-alert__icon {
    height: 38px;
    min-width: 38px;
    font-size: 27px !important;
  }
}
@media screen and (max-width: 360px) {
  .open-order-header .v-toolbar__title {
    font-size: 1.1rem;
  }
  .open-order-header .v-btn:not(.v-btn--round).v-size--default {
    font-size: 12px;
  }
  .open-order-header .v-alert {
    font-size: 14px;
  }
  .open-order-header .v-alert--prominent .v-alert__icon {
    height: 30px;
    min-width: 30px;
    font-size: 24px !important;
  }
  .open-order-header .col {
    padding: 10px;
  }
}
@media screen and (max-width: 320px) {
  .open-order-header .v-toolbar__title,
  .open-order-header .v-application .text-h6 {
    font-size: 1rem !important;
  }
  .open-order-header .v-btn:not(.v-btn--round).v-size--default {
    font-size: 11px;
  }
  .open-order-header .v-alert {
    font-size: 14px;
  }
}
.oval {
  width: 72px !important;
  border-radius: 100px / 50px;
}
</style>
